// ====================================================================
// GoSol Intro Animation
// - Plays once for visitors (except during development)
// - Skips in Shopify Theme Editor
// - Respects prefers-reduced-motion 
// ====================================================================

const IS_DEVELOPMENT = false;
const INTRO_STORAGE_KEY = "gosolIntroPlayed";

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("intro-overlay");
  const words = gsap.utils.toArray(".intro-word");

  if (!overlay || !words.length) return;

  const shouldSkipIntro =
    document.documentElement.classList.contains("shopify-design-mode") ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    (!IS_DEVELOPMENT && localStorage.getItem(INTRO_STORAGE_KEY));

  if (shouldSkipIntro) {
    overlay.remove();
    return;
  }

  if (!IS_DEVELOPMENT) {
    localStorage.setItem(INTRO_STORAGE_KEY, "true");
  }

  const introTimeline = gsap.timeline();

  introTimeline
    .to(words, {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 0.85,
      stagger: 0.25,
      ease: "power2.out",
    })
    .to({}, {
      duration: 0.9
    })
    .to(overlay, {
      clipPath: "inset(0 0 100% 0)",
      duration: 1.05,
      ease: "power3.inOut",
      onComplete: () => overlay.remove()
    }, "-=0.10");
});